import React from 'react';
import { Section } from './ui/Section';
import { WindIcon, UserIcon, BrainIcon, LampIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function MechanismSection() {
  const phases = [{
    icon: WindIcon,
    title: '1. Downshift (Breath)',
    desc: 'A 2–4 minute cue that signals safety to your nervous system immediately.'
  }, {
    icon: UserIcon,
    title: '2. Drain (Body)',
    desc: 'A 7-minute tension release targeting the jaw, neck, chest, and hips.'
  }, {
    icon: BrainIcon,
    title: '3. Decode (Mind)',
    desc: "A structured 'container' for racing thoughts (no positive thinking required)."
  }, {
    icon: LampIcon,
    title: '4. Dim (Environment)',
    desc: 'Simple switches that retrain your bedroom into a powerful sleep trigger.'
  }];
  return <Section className="bg-navy-900" dark={true} data-id="element-137">
      <div className="text-center mb-16" data-id="element-138">
        <h2 className="text-3xl md:text-5xl font-serif mb-6" data-id="element-139">
          The problem isn't you.{' '}
          <span className="text-gold-400 italic" data-id="element-140">It's the order.</span>
        </h2>
        <p className="text-xl text-cream-100/70 max-w-2xl mx-auto" data-id="element-141">
          Most people try to fix sleep after anxiety has already taken over. The
          Serenity Cycle works because it starts before the spiral begins.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-142">
        {phases.map((phase, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-navy-800 p-8 rounded-2xl border border-navy-700 hover:border-gold-500/30 transition-colors duration-300" data-id="element-143">
            <div className="w-12 h-12 bg-navy-900 rounded-full flex items-center justify-center mb-6 border border-navy-700 shadow-inner" data-id="element-144">
              <phase.icon className="w-6 h-6 text-gold-400" data-id="element-145" />
            </div>
            <h3 className="text-xl font-serif text-cream-50 mb-3" data-id="element-146">
              {phase.title}
            </h3>
            <p className="text-cream-100/70 leading-relaxed" data-id="element-147">{phase.desc}</p>
          </motion.div>)}
      </div>

      <div className="mt-16 text-center" data-id="element-148">
        <p className="text-2xl font-serif italic text-gold-400" data-id="element-149">
          It's not long. It's not complicated. It's repeatable.
        </p>
      </div>
    </Section>;
}